import { Box, Link, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import EvidenceResourcesTab from "../../../../Evidence/components/EvidenceResourcesTab";
import EvidenceLoadingSkeleton from "../../../../Evidence/components/common/EvidenceLoadingSkeleton";
import { CheckStatus } from "../../../../../utils/enums";

const EvidenceSetDetails = ({
  checkDetails,
  activeCheckId,
  checkCategory,
  onRefetch,
  loading,
  auditEndDate,
  needsManualEvidence = false,
  onRequestManualEvidence,
}) => {
  const theme = useTheme();

  // Loading state
  if (loading) {
    return <EvidenceLoadingSkeleton />;
  }

  // None of the control's checks have evidence
  if (needsManualEvidence) {
    return (
      <Box
        sx={{
          flex: 1,
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          border: `1px solid ${theme.customColors.border.main}`,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 600,
            color: theme.customColors.text.strong,
          }}
        >
          No evidence found for this control
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            color: theme.customColors.text.secondary,
            maxWidth: 520,
          }}
        >
          There are no resources to test for this control, so manual evidence
          is needed to review it.
          {onRequestManualEvidence && (
            <>
              {" "}
              <Link
                component="button"
                type="button"
                underline="hover"
                onClick={onRequestManualEvidence}
                sx={{ fontSize: "14px", fontWeight: 600, verticalAlign: "baseline" }}
              >
                Request manual evidence
              </Link>
            </>
          )}
        </Typography>
      </Box>
    );
  }

  // No check selected state
  if (!checkDetails) {
    return (
      <Box
        sx={{
          flex: 1,
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          border: `1px solid ${theme.customColors.border.main}`,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 4,
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            color: theme.customColors.text.secondary,
            textAlign: "center",
          }}
        >
          Select a check to view its details
        </Typography>
      </Box>
    );
  }

  // Render EvidenceResourcesTab - it handles all category logic and fallbacks
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: alpha(theme.customColors.border.main, 0.7),
          borderRadius: "10px",
          "&:hover": {
            backgroundColor: alpha(theme.customColors.border.main, 0.7),
          },
        },
      }}
    >
      <EvidenceResourcesTab
        checkDetails={checkDetails}
        activeCheckId={activeCheckId}
        checkCategory={checkCategory}
        onRefetch={onRefetch}
        onRegisterRefetch={() => {}}
        isAuditorView={false}
        auditEndDate={auditEndDate}
        defaultStatusFilter={[CheckStatus.PASS]}
      />
    </Box>
  );
};

export default EvidenceSetDetails;
